<template>
  <v-row>
    <v-col cols="3">
      <div class="grid">
        <div class="grid-title">
          <h4>{{$t("_ACCOUNT_SETTING.AVATAR")}}</h4>
        </div>
        <div class="grid-body">
          <v-progress-linear
            color="warning"
            indeterminate
            rounded
            height="3"
            v-if="isLoading"
          ></v-progress-linear>
          <div
            class="square"
            @mouseover="changeAvatarOverlay(true)"
            @mouseleave="changeAvatarOverlay(false)"
            v-if="!isLoading"
          >
            <img
              v-if="!data.avatar"
              src="@/assets/svg/account-circle.svg"
              class="square-content p-3"
            />
            <v-img v-if="data.avatar" :src="data.avatar" class="square-content" />
            <v-overlay :absolute="true" :value="showAvatarOverlay">
              <label for="input-file">
                <v-btn disabled style="background-color: #fff!important">
                  <v-icon style="color: #173d8f!important">mdi-upload</v-icon>
                </v-btn>
              </label>
              <v-btn
                v-if="data.avatar"
                @click="deleteAvatar"
                color="error"
                class="ml-3"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-overlay>
          </div>
        </div>
      </div>
    </v-col>
    <v-col cols="9">
      <div class="grid">
        <div class="grid-title">
          <h4>{{$t("_ACCOUNT_SETTING.USER_INFO")}}</h4>
        </div>
        <v-progress-linear
          color="warning"
          indeterminate
          rounded
          height="3"
          v-if="isLoading"
        ></v-progress-linear>
        <div class="grid-body p-3 border-top-unset" v-if="!isLoading">
          <v-form ref="form" lazy-validation v-on:submit.prevent>
            <v-row>
              <v-col cols="6" class="pt-0 pb-0">
                <label>{{$t("_ACCOUNT_SETTING.USERNAME")}}</label>
                <v-text-field 
                  disabled 
                  v-model="data.userName"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="6" class="pt-0 pb-0">
                <label>{{$t("_ACCOUNT_SETTING.FULLNAME") + $t("REQUIRED")}}</label>
                <v-text-field 
                  outlined
                  dense
                  :rules="[rules.required]"
                  v-model="data.fullName"
                  length="255"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="pt-0 pb-0">
                <label>{{$t("_ACCOUNT_SETTING.GENDER") + $t("REQUIRED")}}</label>
                <v-radio-group v-model="data.gender" row class="input-gender">
                  <v-radio
                    color="#173d8f"
                    :label="$t('_ACCOUNT_SETTING.GENDER_MALE')"
                    :value="1"
                  ></v-radio>
                  <v-radio
                    color="#173d8f"
                    :label="$t('_ACCOUNT_SETTING.GENDER_FEMALE')"
                    :value="0"
                  ></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="6" class="pt-0 pb-0">
                <label>{{$t("_ACCOUNT_SETTING.EMAIL") + $t("REQUIRED")}}</label>
                <v-text-field
                  outlined
                  disabled
                  dense
                  :rules="[rules.required, rules.email]"
                  v-model="data.email"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pt-0 pb-0">
                <label>{{$t("_ACCOUNT_SETTING.PHONE_NUMBER") + $t("REQUIRED")}}</label>
                <!-- <v-text-field
                  outlined
                  dense
                  :rules="[rules.required, rules.number]"
                  v-model="data.phoneNumber"
                  maxlength="10"
                >
                </v-text-field> -->
                 <div>
                  <vue-tel-input class="input-tel"  :class="phone.valid ? '' : 'border-danger'" v-model="phone.number" @input="onInput" :valid-characters-only="true" :preferredCountries="['vn']" :inputOptions="{
                    placeholder: $t('CONTACT_PHONE')
                  }" :dropdownOptions="{
                    showFlags: true,
                    showSearchBox: true,
                    showDialCodeInList: true
                  }"></vue-tel-input>
                </div>
              </v-col>
              <v-col cols="6" class="pt-0 pb-0">
                <label>{{$t("_ACCOUNT_SETTING.ADDRESS")}}</label>
                <v-text-field
                  outlined
                  dense
                  v-model="data.address"
                  maxlength="255"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="pt-0 pb-0">
                <label>{{$t("_ACCOUNT_SETTING.POSITION")}}</label>
                <v-text-field
                  v-model="data.position"
                  outlined
                  dense
                  maxlength="255"
                >
                </v-text-field>
              </v-col>
              <v-col cols="6" class="pt-0 pb-0">
                <label>{{$t("_ACCOUNT_SETTING.GROUP")}}</label>
                <v-text-field
                  outlined
                  dense
                  disabled 
                  v-model="data.userGroup"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <div class="text-right mt-2">
                <v-btn color="primary" class="pl-10 pr-10" @click="validateInfo">{{$t('SAVE')}}</v-btn>
            </div>
          </v-form>
        </div>
      </div>

      <div  class="grid mt-5">
        <div class="grid-title">
          <h4>{{$t("_ACCOUNT_SETTING.CHANGE_PASSWORD")}}</h4>
          <v-btn @click="enableChangePassword" color="primary">
            <v-icon size="18" class="mr-1">mdi-pencil</v-icon>
            {{$t('EDIT')}}
          </v-btn>
        </div>
        <div v-if="showChangePassword" class="grid-body p-3">
          <v-row>
            <v-col cols="6">
              <label
                class="label-input"
              >{{$t("_ACCOUNT_SETTING.CURRENT_PASS") + $t("REQUIRED")}}</label>
              <input-text
                type="password"
                classList="current-password"
                id="fdjdfjkf"
                :model.sync="data.oldPassword"
                :error.sync="errorPassword.oldPassword.error"
              />
            </v-col>
            <v-col cols="6"></v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <label class="label-input">{{$t("_ACCOUNT_SETTING.NEW_PASS") + $t("REQUIRED")}}</label>
              <input-text
                type="password"
                :model.sync="data.newPassword"
                :error.sync="errorPassword.newPassword.error"
              />
            </v-col>
            <v-col cols="6">
              <label
                class="label-input"
              >{{$t("_ACCOUNT_SETTING.NEW_PASS_REPEAT") + $t("REQUIRED")}}</label>
              <input-text
                type="password"
                :model.sync="data.retypeNewPassword"
                :isRealtimeValidate="true"
                :error.sync="errorPassword.retypeNewPassword.error"
                :errorMessage="errorPassword.retypeNewPassword.message"
                :successMessage="errorPassword.retypeNewPassword.successMessage"
              />
            </v-col>
          </v-row>
          <div class="text-right mt-2">
            <v-btn color="primary" class="pl-10 pr-10" @click="validatePassword">{{$t('SAVE')}}</v-btn>
          </div>
        </div>
      </div>
    </v-col>
    <upload-avatar @completed="completedUpload" />
  </v-row>
</template>

<style lang="scss" scoped>
.square {
  position: relative;
  flex-basis: 100%;
  box-sizing: border-box;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  &::before {
    content: "";
    display: block;
    padding-top: 100%;
  }
  & .square-content {
    border-radius: inherit;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }
}
.btn-icon {
  min-width: 50px;
  min-height: 50px;
  padding: 0;
}
</style>

<script>
import Input from "@/components/Utils/Input.vue";
import UploadAvatarComponent from "@/components/Account/UploadAvatarComponent.vue";
import { getAsError, getAsPassError } from "@/_helpers/config.js";
import { REGEX_PHONE } from "@/_helpers/constant.js";
import eventBus from "@/_helpers/event-bus.js";

import { _validateFormI18n, _alert } from "@/_helpers/function.js";
import { authenticationService } from "@/_services";
import { service } from "@/_services/Account/Setting/account-setting.service.js";
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { systemService } from "@/_services/system-data.service.js";

export default {
  components: {
    "input-text": Input,
    "upload-avatar": UploadAvatarComponent,
    Treeselect
  },
  data() {
    return {
      isLoading: false,
      data: {
        gender: 1
      },
      error: getAsError(), // Always get new error object when created component
      errorPassword: getAsPassError(), // Always get new errorPassword object when created component
      showAvatarOverlay: false,
      showUploadController: false,
      showChangePassword: false,
      rules: {
        required: value => !!value || this.$t("_REGISTER.REQUIRED_FIELD"),
        number: value => value >= 0 || this.$t("DATA_INPUT_INVALID"),
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || this.$t("EMAIL_INVALID")
        }
      },
      optionCountry: [],
      areaCode: null,
      telephone: null,
      rulesPhone: {
        required: value => !!value || this.$t('_ACCOUNT_SETTING.PHONE_NUMBER') + ' ' + this.$t('SERVICE.NOT_EMPTY'),
        counter: value => (value && value.length <= 10 && value.length >= 6) || this.$t('ERROR_PHONE_NUMBER_LENGTH'),
        phone: value => {
          const pattern = /^[1-9]{1}\d+$/
          return pattern.test(value) || this.$t('ERROR_PHONE_NUMBER_STRING')
        },
      },
      lang: this.$i18n.locale,
      phone: {
          number: "",
          valid: false
      },
    };
  },
  watch: {
    data: {
      handler(value) {
        let newPass = value.newPassword;
        let newRetypePass = value.retypeNewPassword;
        if (newPass && newRetypePass) {
          if (newPass == newRetypePass) {
            this.errorPassword.retypeNewPassword.error = false;
            this.errorPassword.retypeNewPassword.successMessage = this.$t(
              "_ACCOUNT_SETTING.MESSAGE_PASSWORD_MATCHED"
            );
            this.errorPassword.retypeNewPassword.message = "";
          } else {
            this.errorPassword.retypeNewPassword.error = true;
            this.errorPassword.retypeNewPassword.successMessage = "";
            this.errorPassword.retypeNewPassword.message = this.$t(
              "_ACCOUNT_SETTING.MESSAGE_PASSWORD_NOT_MATCHED"
            );
          }
        } else {
          this.errorPassword.retypeNewPassword.error = false;
          this.errorPassword.retypeNewPassword.successMessage = "";
          this.errorPassword.retypeNewPassword.message = "";
        }
      },
      deep: true
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    onInput(formattedNumber, { number, valid, country }) {      
        this.phone.number = number;
        this.phone.valid = valid;
      },
    // Run when start
    initialize() {
      // Call service
      this.getProfile();
    },
    // Get user profile
    getProfile() {
      this.isLoading = true;
      service
        .getProfile()
        .then(res => {
          this.data = res.data;
          this.phone.number = this.data.phoneNumber
        })
        .finally(() => (this.isLoading = false));
    },
    // async getArea() {
    //   this.optionCountry = [];
    //    await systemService.getAreaCode().then(res => {
    //     res.data.forEach(x => {
    //       if (x.phoneCode) {
    //         this.optionCountry.push( 
    //           {
    //             id: x.phoneCode,
    //             label: x.locationI18nSet.find(x => x.lang == this.lang).name,
    //             flag: 'https://static.oneinventory.com/flags/' + x.flagURL
    //           }
    //         );
    //       }
		// 		});
    //     this.optionCountry.forEach(e => {
    //       if (this.data.phoneNumber.includes(e.id)) {
    //         this.areaCode = e.id;
    //       }
    //     });
    //     this.telephone = this.data.phoneNumber.substring(this.areaCode.length, this.data.phoneNumber.length);
    //   });
    // },
    // Validate user info, if valid then call updateInfo()
    validateInfo() {
      let form_validate = this.$refs.form.validate();
      if (!form_validate || !this.phone.valid) return false;
      this.updateInfo();
    },
    // Update user info
    updateInfo() {
      let temp = {
        fullName: this.data.fullName,
        gender: this.data.gender,
        phoneNumber: this.phone.number,
        position: this.data.position,
        email: this.data.email,
        address: this.data.address
      };
      this.isLoading = true;
      service
        .updateInfo(temp)
        .then(res => {
          if (res) {
            _alert(res, this.$t(res.data), false);
            if (res.responseCode === 0) {
              eventBus.$emit("EVENT_RELOAD_USER");
            }
          }
        })
        .finally(() => (this.isLoading = false));
    },
    // Show change password inputs
    async enableChangePassword() {
      this.showChangePassword = true;
      await setTimeout(function() {
        document.documentElement.scrollTop = window.innerHeight;
      }, 200);
      // if (document.querySelector("input.current-password"))
      //   document.querySelector("input.current-password").focus();
    },
    // Validate password, if valid then call updatePassword()
    validatePassword() {
      this.errorPassword.retypeNewPassword.successMessage = "";
      let { isValid, error } = _validateFormI18n(this.data, this.errorPassword);
      this.errorPassword = error;
      if (!isValid) return false;
      if (this.data.newPassword !== this.data.retypeNewPassword) {
        const errorMessage = this.$t(
          "_ACCOUNT_SETTING.ERROR_PASSWORD_NOT_MATCH"
        );
        this.errorPassword.retypeNewPassword.error = true;
        this.errorPassword.retypeNewPassword.message = errorMessage;
        _alert(null, errorMessage, false);
        return false;
      }
      this.updatePassword();
    },
    // Update password
    updatePassword() {
      let temp = {
        oldPassword: this.data.oldPassword,
        newPassword: this.data.newPassword
      };
      this.isLoading = true;
      service
        .updatePassword(temp)
        .then(res => {
          if (res) {
            if (res.responseCode === 0) {
              // Logout and redirect to login page
              _alert(res, this.$t(res.data), false);
              if (this.domain.includes('ezcrs') || this.domain.includes('ezcms') || (this.dataMain && this.dataMain.isLoginAdmin === false)) {
                authenticationService.logout();
                this.$oidc.signoutRedirect();
              } else {
                localStorage.removeItem("currentUser");
                this.$router.push({ name: "login-admin" });
              }
            }
            if (res.data === "PASSWORD_OLD_INCORRECT") {
              // Override message keyword
              this.errorPassword.oldPassword.error = true;
              _alert(
                res,
                this.$t("_ACCOUNT_SETTING.ERROR_PASSWORD_INVALID"),
                false
              );
            } else {
              _alert(res, this.$t(res.data), false);
            }
          }
        })
        .finally(() => (this.isLoading = false));
    },
    // Open upload avatar dialog
    showUploadDialog() {
      this.showUploadController = true;
    },
    // Complete upload avbtar
    completedUpload() {
      this.showUploadController = false;
      eventBus.$emit("EVENT_RELOAD_USER");
      this.initialize();
    },
    // Delete user avatar
    deleteAvatar() {
      this.isLoading = true;
      service
        .deleteAvatar()
        .then(res => {
          if (res) {
            if (res.responseCode === 0) {
              // Reload user info
              this.getProfile();
              eventBus.$emit("EVENT_RELOAD_USER");
            }
            _alert(res, this.$t(res.data), false);
          }
        })
        .finally(() => (this.isLoading = false));
    },
    changeAvatarOverlay(visible) {
      this.showAvatarOverlay = visible;
    }
  }
};
</script>
<style lang="scss" scoped>
.label-upload {
  background: #fff;
  width: 50px;
}
</style>